// Import model
import { DataviewCustomerResponse } from '../models/DataviewCustomerResponse';

// Import base class serializer

// Import dependency types (models and enums used in properties)
import { Customer } from '../models/Customer';
import { DataView } from '../models/DataView';
import { FilterCustomerRequest } from '../models/FilterCustomerRequest';

// Import dependency serializers (for complex types)
import { CustomerSerializer } from './CustomerSerializer';
import { DataViewSerializer } from './DataViewSerializer';
import { FilterCustomerRequestSerializer } from './FilterCustomerRequestSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for DataviewCustomerResponse - handles JSON serialization and deserialization with type validation
 */
export class DataviewCustomerResponseSerializer {
  /**
   * Deserializes a JSON string into a DataviewCustomerResponse instance
   */
  static deserialize(json: string): DataviewCustomerResponse {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a DataviewCustomerResponse instance
   */
  static fromObject(obj: any): DataviewCustomerResponse {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to DataviewCustomerResponse');
    }


    const instance: DataviewCustomerResponse = {
      result: obj['Result'] ? (obj['Result'] as any[]).map((item: any) =>
        CustomerSerializer.fromObject(item)
      ) : [] as any,
      request: obj['Request'] ? FilterCustomerRequestSerializer.fromObject(obj['Request']) : undefined as any,
      dataView: obj['DataView'] ? DataViewSerializer.fromObject(obj['DataView']) : undefined as any,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of DataviewCustomerResponse instances
   */
  static deserializeArray(json: string): DataviewCustomerResponse[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a DataviewCustomerResponse instance to a JSON string
   */
  static serialize(instance: DataviewCustomerResponse): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a DataviewCustomerResponse instance to a plain object
   */
  static toObject(instance: DataviewCustomerResponse): any {
    return {
      'Result': instance.result?.map((item: any) =>
        CustomerSerializer.toObject(item)
      ),
      'Request': instance.request ? FilterCustomerRequestSerializer.toObject(instance.request) : undefined,
      'DataView': instance.dataView ? DataViewSerializer.toObject(instance.dataView) : undefined,
    };
  }

  /**
   * Serializes an array of DataviewCustomerResponse instances to a JSON string
   */
  static serializeArray(instances: DataviewCustomerResponse[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
